'use client';

import { faFire } from '@fortawesome/pro-solid-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';
import { CartItem } from '@/types/cart.types';
import { getCartItemPrice, hasCartItemDiscount } from '@/utils/cart/get-cart-total.util';
import { currencyFormatter } from '@/utils/formatters/currency';
import { Typography } from '@/components/ui/typography/typography.component';

interface CartItemProcedureProps {
  item: CartItem;
}

export function CartItemProcedure({ item }: CartItemProcedureProps) {
  const originalPrice = hasCartItemDiscount(item) ? item.price : undefined;
  const hasDiscount = originalPrice !== undefined;
  const effectivePrice = getCartItemPrice(item);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col">
        <Typography
          className="text-base leading-6 text-gray-700"
          data-testid={DataTestIdEnum.CART_ITEM_PROCEDURE}
        >
          {item.procedure.name}
        </Typography>

        <div className="flex flex-wrap items-center gap-1">
          <Typography
            className={`text-base font-bold leading-6 ${hasDiscount ? 'text-pink-700' : 'text-gray-700'}`}
            data-testid={DataTestIdEnum.CART_ITEM_PRICE}
          >
            {currencyFormatter(effectivePrice)}
          </Typography>

          {hasDiscount && (
            <Typography
              className="text-xs font-light leading-4 text-gray-700 line-through"
              data-testid={DataTestIdEnum.CART_ITEM_ORIGINAL_PRICE}
            >
              {currencyFormatter(originalPrice)}
            </Typography>
          )}
        </div>
      </div>

      {hasDiscount && (
        <p
          className="flex w-full items-center justify-center gap-1 rounded-sm border border-pink-200 bg-pink-100 px-2 py-1 text-base font-semibold leading-6 text-pink-700"
          data-testid={DataTestIdEnum.CART_ITEM_PROMOTION_PILL}
        >
          <Icon icon={faFire} className="h-3 w-3" />
          Preço promocional
        </p>
      )}
    </div>
  );
}
